<div [formGroup]="form">
    <div>
        @switch (component.controlType) {
            @case ('textbox') {
                <input pInputText
                       [formControlName]="component.key" [id]="component.key"
                       [type]="component.type" [placeholder]="component.placeholder">
            }
            @case ('textboxNumber') {
                <label>{{component.label}}</label>
                <p-inputNumber id="montoInversion" [formControlName]="component.key" (keyup)="onKeyUp($event)"
                               [placeholder]="component?.placeholder" [pTooltip]="component?.placeholder" [min]="0"
                               mode="currency" currency="USD" locale="en-US">
                </p-inputNumber>
            }
            @case ('dropdown') {
                <label>{{component.label}}</label>
                <p-dropdown
                    *ngIf="!component?.completed && component.type!=='hidden'" (onChange)="setDropdown($event.value)"
                    [options]="component?.options" optionLabel="value" [showClear]="true"
                    [formControlName]="component.key"
                    [placeholder]="component?.placeholder"
                    [checkmark]="true"
                    filterBy="descripcion"
                    [pTooltip]="component?.label"
                    tooltipPosition="top"></p-dropdown>
                <div *ngIf="component?.completed">
                    @for (va of component?.values; track component?.values) {
                        <div class="field">
                            <p-tag icon="pi pi-tag" value="{{va.value}}"/>
                        </div>
                    }
                </div>
            }
            @case ('multiselect') {
                <p-multiSelect
                    *ngIf="!component?.completed"
                    [options]="component?.options" optionLabel="value" [showClear]="true"
                    [formControlName]="component.key"
                    placeholder="Seleccione"
                    [filter]="true"
                    filterBy="descripcion"
                    [pTooltip]="component?.label"
                    display="chip"
                    tooltipPosition="top"
                />
                <div *ngIf="component?.completed">
                    @for (va of component?.values; track component?.values) {
                        <div class="field">
                            <p-tag icon="pi pi-tag" value="{{va.value}}"/>
                        </div>
                    }
                </div>
            }
        }
    </div>
    @if (!isValid && !component.completed && component.required) {
        <div class="text-small" style="color:red">{{ component.label }} es requerido</div>
    }
    @if (component.key=='montoInversion' && form.get(component.key)?.value == null) {
        <div class="text-small" style="color:red">Ingresar el {{ component.label }}</div>
    }
</div>
